import { createAction } from "@reduxjs/toolkit";
import { clearReportingClassModules } from "@store/reducers/reportingReducer";

export { clearReportingClassModules };

type ReportingDataFilterParams = {
  province2?: string | null;
  ward2?: string | null;
  school?: string,
  classes?: string,
  module?: string,
  submodule?: string,
  export_data?: boolean;
  from_date?: string,
  to_date?: string,
  page_size?: number,
  page?: number,
}
export type ExamsReportFilterType = {
  province2?: string | null;
  ward2?: string | null;
  school?: string,
  classes?: string,
  module?: string,
  submodule?: string,
  export_data?: boolean;
  from_date?: string,
  to_date?: string,
  page_size?: number,
  page?: number,
}

const FETCH_REPORTING_FILTERS_1A = 'FETCH_REPORTING_FILTERS_1A';
const FETCH_REPORTING_FILTERS_2A = 'FETCH_REPORTING_FILTERS_2A';
const FETCH_REPORTING_FILTERS_1B = 'FETCH_REPORTING_FILTERS_1B';
const FETCH_REPORTING_FILTER_DATA = 'FETCH_REPORTING_FILTER_DATA';
const FETCH_REPORTING_2A_FILTER_DATA = 'FETCH_REPORTING_2A_FILTER_DATA';
const FETCH_ADMIN_REPORTING_DETAIL = 'FETCH_ADMIN_REPORTING_DETAIL';
const FETCH_STUDENT_REPORTING_DETAIL = 'FETCH_STUDENT_REPORTING_DETAIL';
const FETCH_REPORTING_EXAMS_FILTER_DATA = 'FETCH_REPORTING_EXAMS_FILTER_DATA';
const FETCH_REPORTING_EXAMS_DETAIL = 'FETCH_REPORTING_EXAMS_DETAIL';
const FETCH_CLASS_MODULES = 'FETCH_CLASS_MODULES';

export const fetchStudentReportingDetail = createAction(FETCH_STUDENT_REPORTING_DETAIL, (submodule_id: number) => ({
  payload: { submodule_id }
}))

export const fetchAdminReportingDetail = createAction(FETCH_ADMIN_REPORTING_DETAIL, (submodule_id: number, student_id: number) => ({
  payload: { submodule_id, student_id }
}))

export const fetchReportingFilters1a = createAction(FETCH_REPORTING_FILTERS_1A, (ReportingDataFilter: ReportingDataFilterParams) => ({
  payload: ReportingDataFilter
}))
export const fetchReportingFilters2a = createAction(FETCH_REPORTING_FILTERS_2A, (ReportingDataFilter: ReportingDataFilterParams) => ({
  payload: ReportingDataFilter
}))

export const fetchReportingFilters1b = createAction(FETCH_REPORTING_FILTERS_1B, (ReportingDataFilter: ReportingDataFilterParams) => ({
  payload: ReportingDataFilter
}))

export const fetchReportingFilterData = createAction(FETCH_REPORTING_FILTER_DATA, (ReportingDataFilter: ReportingDataFilterParams) => ({
  payload: ReportingDataFilter
}))
export const fetchReporting2aFilterData = createAction(FETCH_REPORTING_2A_FILTER_DATA, (ReportingDataFilter: ReportingDataFilterParams) => ({
  payload: ReportingDataFilter
}))
export const fetchReportingExamsFilterDataType = createAction(FETCH_REPORTING_EXAMS_FILTER_DATA, (ReportingDataFilter: ExamsReportFilterType) => ({
  payload: ReportingDataFilter
}))
export const fetchExamsReportingDetail = createAction(FETCH_REPORTING_EXAMS_DETAIL, (student_id: number, submodule_id: number) => ({
  payload: { student_id, submodule_id }
}))
export const fetchListClassModulesFromReporting = createAction<any>(
    FETCH_CLASS_MODULES,
    ({ page, pageSize, classId, status }: { page: number, pageSize: number, classId: number, status?: number | null }) => ({
        payload: {
            page: page,
            pageSize: pageSize,
            classId: classId,
            status: status,
        },
    }),
);
